import { Link } from 'react-router-dom';
import { categories, siteInfo } from '@/mocks/comics';

export default function Footer() {
  const handleCategoryClick = (slug: string) => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-background-950 text-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-open-line text-lg text-background-50"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50">
                韩漫网
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              {siteInfo.description}
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-100 mb-4">
              漫画分类
            </h4>
            <div className="grid grid-cols-2 gap-2">
              {categories.filter((c) => c.slug !== 'all').map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  onClick={() => handleCategoryClick(cat.slug)}
                  className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-100 mb-4">
              快速链接
            </h4>
            <div className="space-y-2">
              <Link
                to="/"
                onClick={() => handleCategoryClick('all')}
                className="block text-sm text-background-400 hover:text-primary-400 transition-colors"
              >
                首页
              </Link>
              <Link
                to="/category/all"
                onClick={() => handleCategoryClick('all')}
                className="block text-sm text-background-400 hover:text-primary-400 transition-colors"
              >
                全部漫画
              </Link>
              <Link
                to="/about"
                onClick={() => handleCategoryClick('all')}
                className="block text-sm text-background-400 hover:text-primary-400 transition-colors"
              >
                关于我们
              </Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-100 mb-4">
              联系方式
            </h4>
            <div className="space-y-2 text-sm text-background-400">
              <p><i className="ri-mail-line mr-2"></i>{siteInfo.email}</p>
              <p className="mt-4 text-xs text-background-500">
                &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有
              </p>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            本站所有漫画内容均来自网络，版权归原作者所有。如侵犯您的权益，请与我们联系。
          </p>
          <p className="text-xs text-background-500 whitespace-nowrap">
            韩漫网 &copy; {new Date().getFullYear()} All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}